module.exports = __webpack_public_path__ + "static/media/call_selected_hover.ff2869e9.svg";